<script setup lang="ts" generic="TValue">
import { type RadioProps, useRadio } from "@formwerk/core";

const props = defineProps<RadioProps<TValue>>();
const { labelProps, inputProps } = useRadio(props);
</script>

<template>
  <label v-bind="labelProps" class="flex items-start gap-1.5 leading-tight">
    <input v-bind="inputProps" class="mt-0.5">
    <slot>
      {{ label }}
    </slot>
  </label>
</template>
